import {
    Box, Button, Card, CardBody,
    CloseButton,
    Flex,
    Select,
    SkeletonText,
    Text
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { HiOutlineOfficeBuilding } from 'react-icons/hi';
import { useSelector } from 'react-redux';
import { useGetPagesQuery } from 'store/BmAccounts/bmAccountApi';
import { truncateString } from 'utils/functions';

function FaceBookPageAdspressoSelector({ adsAccount, onSelectedPage, selectedPageId, objective = '', destinationType = '', context = '' }) {

    const { adsAccountId, adsAccountName } = adsAccount || {};
    const [selectedPage, setselectedPage] = useState(selectedPageId || '');
    const userInfo = useSelector((state) => state.auth?.userInfo);
    const [showCard, setShowCard] = useState(true);
    // const { data: facebookPages, isLoading } = useGetFacebookPagesQuery(account_id);

    const { data: facebookPages = [], isLoading:isFbPageLoading } = useGetPagesQuery(
        { search: '',  },
    );

    useEffect(() => {
        if(selectedPageId){
            setselectedPage(selectedPageId || '');
        }
    }, [selectedPageId]);

    const handleEventPageChange = (event) => {
        const pageId = event.target.value;
        setShowCard(true);
        setselectedPage(pageId);
        onSelectedPage(pageId, adsAccountId);
    };
    

    return (
        <Box>
            <Flex gap={2} direction={'column'}>
                {context === 'single' ? null :
                    <Flex alignItems={'center'} gap={2}>
                        <Text fontWeight={'bold'} fontSize={'12px'}>{truncateString(adsAccountName, 40)}</Text>
                        <Text fontSize={'12px'}>({adsAccountId})</Text>
                    </Flex>
                }

                <Flex>
                    {isFbPageLoading ? (
                        <Flex width={'100%'}>
                         <SkeletonText width="80%" noOfLines={2}  skeletonHeight={2}/>
                        </Flex>
                    ) : (
                        <Flex direction={'column'} gap={2} w={'100%'}>
                            <Select
                                placeholder="Facebook page"
                                value={selectedPage}
                                onChange={handleEventPageChange}
                                borderRadius={'md'}
                                size={'sm'}
                                isDisabled={userInfo?.role !== 'client'}
                            >
                                {facebookPages?.map((page) => (
                                    <option key={page?.id} value={page?.id}>
                                        {page?.name ? page?.name : 'Unnamed Page'}
                                    </option>
                                ))}
                            </Select>
                            {selectedPage && objective === 'OUTCOME_LEADS' && destinationType === 'ON_AD' && (
                                (() => {
                                const selectedPageObj = facebookPages.find(p => p.id === selectedPage);
                                if (selectedPageObj && selectedPageObj.leadgen_tos_accepted === false) {
                                    return (
                                        <Flex direction={'column'} gap={2}>
                                        <Text color="red.500" fontSize="12px">
                                          Terms of Service Not Accepted: You can't run lead ads until your Facebook Page accepts Facebook's Lead Generation Terms of Service.
                                        </Text>
                                  
                                        {/* Only show card if showCard is true */}
                                        {showCard && (
                                          <Card bg="#fff" borderRadius="5px" p={2} borderLeft="4px solid gray" position="relative">
                                            <CloseButton
                                              position="absolute"
                                              top="6px"
                                              right="6px"
                                              size="sm"
                                              onClick={() => setShowCard(false)}
                                            />
                                            <CardBody display="flex" alignItems="center" gap={2} p={0}>
                                                {/* Icon, vertically centered */}
                                                <Box mt="2px">
                                                    <HiOutlineOfficeBuilding color="gray" />
                                                </Box>

                                                {/* Text and Button in a column */}
                                                <Box>
                                                    <Text fontSize="12px" mb={3}>
                                                        Please read and accept Meta's Lead Ads Terms before creating your ad.
                                                    </Text>
                                                    <Button
                                                        as="a"
                                                        href={`https://www.facebook.com/ads/leadgen/tos/?page_id=${selectedPage}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        variant="outline"
                                                        colorScheme="gray"
                                                        size="sm"
                                                        bg="transparent"
                                                    >
                                                    View terms
                                                    </Button>
                                                </Box>
                                            </CardBody>
                                          </Card>
                                        )}
                                      </Flex>
                                    );
                                }
                                
                                return null;
                                })()
                            )}
                        </Flex>
                    )}
                </Flex>
            </Flex>
        </Box>
    )
}

export default FaceBookPageAdspressoSelector